/** 应用配置常量（从环境变量读取，支持不同环境独立配置） */

/** A4 每页字数（用于大纲页数估算） */
export const WORDS_PER_PAGE = parseInt(
  process.env.REACT_APP_WORDS_PER_PAGE || '800',
  10
);
